import { checkGate } from '@eventbrite/statsig';

export const checkEnablePayPalLineItemsFeatureGate = () =>
    checkGate('checkout_enable_paypal_line_items');
